import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./acceso/acceso.module').then( m => m.LoginPageModule)
  },
  {
    path: 'cotizacion',
    loadChildren: () => import('./cotizador/cotizador.module').then( m => m.CotizacionPageModule)
  },  {
    path: 'nueva-pieza-modal',
    loadChildren: () => import('./nueva-pieza-modal/nueva-pieza-modal.module').then( m => m.NuevaPiezaModalPageModule)
  }



];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
